<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:modelValue']);

const useShippingAddress = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});
</script>

<template>
  <div class="mb-4">
    <div class="flex items-center justify-between mb-3">
      <div class="flex items-center gap-2">
        <i class="pi pi-map-marker text-gray-600" style="font-size: 18px;"></i>
        <div>
          <label class="block text-sm font-medium text-gray-700">Add Shipping Address</label>
          <p class="text-xs text-gray-500">Optional — used if order needs to be shipped.</p>
        </div>
      </div>
      <input v-model="useShippingAddress" type="checkbox" class="toggle" />
    </div>
  </div>
</template>

<style scoped>
input.toggle:checked {
  background-color: #a855f7 ;
}
</style>
